import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=f4d85ed2&scoped=true&"
import script from "./PercentageBar.vue?vue&type=script&lang=js&"
export * from "./PercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=f4d85ed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d85ed2",
  null
  
)

export default component.exports